const formatNumber = require('format-number')({
    integerSeparator: " ",
    decimalsSeparator: " ",
    decimal: ","
});

const payment = (price, rate, term, pv) => {
    console.log(price, rate, term, pv);
    if (window.cian_calculator_find_payment) {
        return window.cian_calculator_find_payment(price, pv, term, rate);
    }
    const i = rate / 12 / 100;
    const pow = Math.pow(i + 1, term * 12);
    const K = i * pow / (pow - 1);
    let payment = Math.round((price - pv) * K);
    if (payment < 0) {
        payment = 0;
    }
    return payment;
};

// Банки в которых нужно показывать токльо аккредитованные ЖК
const BANKS = {
    unicredit: {name: "ЮниКредит Банк"}
};


export class OfferSerp extends HTMLElement {
    connectedCallback() {
        if (!document.querySelector('style[cian-content-serp-card]')) {
            const s = document.createElement('style');
            s.setAttribute('cian-content-serp-card', "");
            s.innerHTML = `
            cian-content-serp-card [title]:hover {color: #508BE2;}
        `;
            document.head.appendChild(s);
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            this.init();
        }
    }

    async init() {
        const closest = this.closest('[cian-query]');
        const withPartnerPrograms = closest.getAttribute('cian-query').includes('partner_programs=true')
        this.querySelector('mortgage-button').setAttribute('isPartnerObject', withPartnerPrograms)
        this.querySelector('call-tracking-button-light').setAttribute('isPartnerObject', withPartnerPrograms)

        // if (this.getAttribute('jk-ref') && !withPartnerPrograms) {
        if (this.getAttribute('jk-ref')) {
            const featureEnabled = !window.cian_disabled_features || !window.cian_disabled_features.includes('replace-with-jk-card');
            console.log(this.getAttribute('jk-ref'), ": ", featureEnabled)

            const notUsed = !closest || !(closest.getAttribute('cian-query') || "").includes("object_type[0]=1");
            if (notUsed && featureEnabled && (!closest || !(closest.getAttribute('cian-query') || "").includes("newobject"))) {
                let rooms = this.getAttribute('jk-rooms');
                try {
                    const response = await fetch("https://gpb-service.content.cian.ru/api/v1/new-building/", {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({name: this.getAttribute('jk-ref')})
                    });
                    const data = await response.json();
                    const {hostname} = window.location;

                    if (data && data.fromDevelopersRooms.length) {
                        const alreadyExist = this.compareDocumentPosition(document.querySelector(`cian-content-serp-card[jk-ref="${this.getAttribute('jk-ref')}"]`)) === 2;
                        if (alreadyExist) {
                            this.innerHTML = `<div></div>`;
                            return;
                        }
                        if (hostname.includes('unicredit')) {
                            const isAcreditate = data.banks.find((bank) => bank.name === BANKS['unicredit'].name);
                            if (isAcreditate) {
                                this.innerHTML = `
                                <cian-content-serp-jk 
                                    jk-ref="${this.getAttribute('jk-ref')}"
                                    ${rooms && rooms.length > 0 ? `rooms='["${rooms}"]'` : ""}
                                ></cian-content-serp-jk>`;
                                return;
                            }
                            this.innerHTML = `<div></div>`;
                            return;
                        }
                        this.innerHTML = `
                            <cian-content-serp-jk 
                                jk-ref="${this.getAttribute('jk-ref')}"
                                ${rooms && rooms.length > 0 ? `rooms='["${rooms}"]'` : ""}
                            ></cian-content-serp-jk>`;
                        return;
                    }
                } catch (e) {
                    console.log({error: e});
                }
            }
        }
        this.addEventListener('click', (e) => {
            console.log('click', e)
            const jkLink = e.target.closest('[jk-ref]');
            if (jkLink && jkLink.tagName !== 'CIAN-CONTENT-SERP-CARD') {
                const customEvent = new CustomEvent('SHOW_JK', {bubbles: true});
                customEvent.jkRef = jkLink.getAttribute('jk-ref');
                customEvent.newTab = true;
                this.dispatchEvent(customEvent);
                return;
            }
            if (!e.target.closest('#call-tracking-button')
                && e.target.nodeName !== 'svg'
                && e.target.nodeName !== 'path') {
                console.log('SHOW_OFFER')
                const customEvent = new CustomEvent('SHOW_OFFER', {bubbles: true});
                customEvent.newTab = true;
                customEvent.offerId = this.getAttribute('offer-id');
                customEvent.clickTarget = e.target;
                this.dispatchEvent(customEvent);
            }
        });
    }
}

export class MortgageMiniCalculator extends HTMLElement {
    connectedCallback() {
        let price = Number.parseInt(this.getAttribute('price'));
        let initialPayment = 0.201 * price;
        let term = 30;
        let totalFloors = Number.parseInt(this.getAttribute('total-floors'));
        const waitFn = () => {
            const render = (rate, defaultTerm, defaultInitialPayment) => {
                console.log(rate, defaultTerm, defaultInitialPayment);
                (this.closest('cian-content-serp-card') || this).dispatchEvent(new CustomEvent('OFFER_SHOW_LIST', {
                    bubbles: true,
                    detail: this.getCalcObject(price, initialPayment, term, totalFloors)
                }));
                this.innerHTML = `
                <div style="color: #262C40; font-size: 22px; line-height: 24px; font-weight: bold">
                    <span style="font-size: 16px; line-height: 20px; font-weight: bold">от </span>${formatNumber(payment(price, rate, defaultTerm || term, ((defaultInitialPayment || 0.1) * price)))}
                                            <span
                                                    style="font-size: 14px; line-height: 24px; font-weight: 600"> ₽ в месяц</span>
                                        </div>
                                        <div style="color: #262C40; font-size: 14px; line-height: 20px"> при
                                            <span style="color: #262C40;font-size: 16px; line-height: 24px;">${formatNumber(rate)}</span>
                                            <span style="color: #262C40;font-size: 14px; line-height: 24px;">%</span>
                                        </div>
                `;
            }
            if (typeof window.cian_calculator_find_rate_async != "undefined") {
                window.cian_calculator_find_rate_async(this.getCalcObject(price, initialPayment, term)).then(({
                                                                                                                  rate,
                                                                                                                  defaultTerm,
                                                                                                                  defaultInitialPayment
                                                                                                              }) => {
                    console.log(arguments);
                    render(Math.round(rate * 100) / 100, defaultTerm, defaultInitialPayment)
                });
            } else if (typeof window.cian_calculator_find_rate != "undefined") {
                const {
                    rate,
                    defaultTerm,
                    defaultInitialPayment
                } = window.cian_calculator_find_rate(this.getCalcObject(price, initialPayment, term));
                render(Math.round(rate * 100) / 100, defaultTerm, defaultInitialPayment);
            } else {
                setTimeout(waitFn, 200);
            }
        };
        waitFn();
    }

    getCalcObject(price, initialPayment, term, totalFloors) {
        return {
            region: this.hasAttribute('region') ? Number.parseInt(this.getAttribute('region')) : 1,
            type: this.getAttribute('type') || 'flat',
            new: this.hasAttribute('new') ? this.getAttribute('new') === "true" : true,
            partner: this.hasAttribute('partner') ? this.getAttribute('partner') === "true" : true,
            builderName: this.getAttribute('builder-name'),
            fullAddress: this.hasAttribute('fullAddress') ? JSON.parse(this.getAttribute('fullAddress')) : [],
            price,
            payroll: false,
            initialPayment,
            term,
            totalFloors
        };
    }
}

export class SeoDistanceBreadcrumb extends HTMLElement {
    attributeChangedCallback() {
        this.init();
    }
    connectedCallback() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            this.init();
        }
    }

    init() {
        const title = this.getAttribute('title');
        const queryString = this.getAttribute('query-string');
        let url = `${window.location.pathname}#${queryString}`;
        if(!!window.location.search) {
            url = `${window.location.pathname}?${queryString}`;
        }
        this.innerHTML = `<a style="color: var(--main-color, #0066CC) !important;text-decoration: none;cursor: pointer; z-index: 1" href="${url}">${title}</a>`
    }
}

